
<template>
  <v-app>
    <component :is="layout">
    </component>
  </v-app>
</template>



<script>
const defaultLayout = "login_layout";
export default {
  name: "App",

  metaInfo: {
            title: 'Kwsoluciones ',
            titleTemplate: '%s | desarrollo de software y paginas web',
        
        meta: [
          { charset: 'utf-8' },
          { name: 'description', content: 'creación de paginas web, sistemas de administrativo, (compras, productos, inventario, ventas, cuentas por cobrar, cuentas por pagar))' },
          { name: 'viewport', content: 'width=device-width, initial-scale=1' }
        ]

      },

  data: () => ({
    //defaultLayout  : 'login_layout'
  }),

  created: function () {
    // `this` points to the vm instance
    //  console.debug(`**** layout a cargar = ${this.$route.meta.layout} ****`)
  },

  //Alberto vega implementacion de reload y time out funciones para detectar uso de mouse y teclado
  mounted() {
    // $('.btn').mousedown(function(event) {
    //   $('#console').append(
    //   	'data-key: ' +
    //   	event.target.getAttribute('data-key') +
    //     '<br>'
    //   )
    // })
    // setTimeout( function() { router.push({ path: '/login'})}, 1800000000);
    //1800000000
  },

  computed: {
    layout() {
      // return (this.$route.meta.layout || defaultLayout)
      return this.$route.meta.layout || defaultLayout;
    },
  },

  methods: {
    eventoClick: function (dato) {
      console.log(dato);
    },

    eventoTeclado: function (event) {
      console.log(event.key);
    },
  },
};
</script>
